


























































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";

@Component({
    components: {},
    props: {}
})

export default class ToolsPanel extends Vue {
    @Prop({required: true}) private readonly diceGeneratorIsVisible!: boolean;
    @Prop({required: true}) private readonly tableIsManageable!: boolean;

    private isOpened: boolean = true;

    mounted(): void
    {

    }

    beforeDestroy(): void
    {

    }

    /**
     * Получить координаты эл-та, относительно которого будет позиционироваться раскрытое меню
     * @param element
     */
    public getButtonPosition(element: HTMLElement): {x: number, y: number}
    {
        const rect = element.getBoundingClientRect();
        const x = rect.x + rect.width;
        const y = rect.y;
        return {x: x, y: y};
    }

    /**
     * Скрыть,показать список инструментов
     * @private
     */
    private toggleToolsList(): void
    {
        this.isOpened = !this.isOpened;
    }

    /**
     * Скрыть,показать дайсомет
     * @private
     */
    private toggleDice(): void
    {
        const coordinates = this.getButtonPosition(this.$refs.diceItem as HTMLElement);
        this.$emit('toggle-dice', coordinates);
    }

    /**
     * Скрыть,показать реакции
     * @private
     */
    private toggleReaction(): void
    {

    }

    /**
     * Скрыть,показать таймер
     * @private
     */
    private toggleTimer(): void
    {
        const coordinates = this.getButtonPosition(this.$refs.timerItem as HTMLElement);
        this.$emit('toggle-timer', coordinates);
    }

    /**
     * Скрыть,показать заметки
     * @private
     */
    private toggleNotes(): void
    {
        const coordinates = this.getButtonPosition(this.$refs.notesItem as HTMLElement);
        this.$emit('toggle-notes', coordinates);
    }

    /**
     * Скрыть,показать таймер
     * @private
     */
    private showAddForm(): void
    {
        this.$emit('show-add-form');
    }
}

